import { createEffect } from "effector";
import { restListHandler } from "@utils/rest/RestClient";
import { TipsResponseDTO } from "@state/em_tips/dto/tips.response.dto";

const tipsUrl = (window as any)?.api_url_tips
  ? (window as any)?.api_url_tips
  : "/ws/tips/";

export const requestGetTips = createEffect({
  handler: restListHandler<TipsResponseDTO>(`${tipsUrl}`),
});
